import React from "react";
import { Card, CardContent, CardMedia, Typography, Box, Fab, CircularProgress } from "@mui/material";
import { ArrowBackIosNew, ArrowForwardIos } from "@mui/icons-material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";

const ShowCard = ({ show, canGoPrevious, canGoNext, handlePrevious, handleNext, reviewLoading, handleReview }) => {
  return (
    <Card sx={{ mt: 3, position: "relative" }}>
      <Box p={2} position="relative">
        <CardMedia
          component="img"
          height="450"
          image={show.posterUrl}
          alt={show.title}
          style={{ objectFit: "contain" }}
        />
        {canGoPrevious && (
          <Fab
            color="default"
            size="small"
            onClick={handlePrevious}
            sx={{
              position: "absolute",
              top: "50%",
              left: 10,
              transform: "translateY(-50%)",
              zIndex: 1,
            }}
          >
            <ArrowBackIosNew fontSize="small" />
          </Fab>
        )}
        {canGoNext && (
          <Fab
            color="default"
            size="small"
            onClick={handleNext}
            sx={{
              position: "absolute",
              top: "50%",
              right: 10,
              transform: "translateY(-50%)",
              zIndex: 1,
            }}
          >
            <ArrowForwardIos fontSize="small" />
          </Fab>
        )}
        <CardContent>
          <Typography variant="h5" align="center">
            {show.title}
          </Typography>
          <Typography
            variant="subtitle1"
            color="textSecondary"
            align="center"
          >
            {show.releaseYear} | {show.genres}
          </Typography>
          <Box mt={2} display="flex" justifyContent="center">
            <Fab
              color="error"
              size="large"
              onClick={() => handleReview(false, show.uniqueId)}
              disabled={reviewLoading}
              sx={{ mr: 4 }}
            >
              {reviewLoading ? <CircularProgress size={24} /> : <ThumbDownIcon />}
            </Fab>
            <Fab
              color="success"
              size="large"
              onClick={() => handleReview(true, show.uniqueId)}
              disabled={reviewLoading}
            >
              {reviewLoading ? <CircularProgress size={24} /> : <ThumbUpIcon />}
            </Fab>
          </Box>
        </CardContent>
      </Box>
    </Card>
  );
};

export default ShowCard;
